import { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ErrorMessage, Input, Label, Skeleton } from '../../atoms'

interface SecretFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  id: string
  label: string
  error?: string
  skeleton?: boolean
}

// A text field for API keys and other secrets: masked by default, with a Show/Hide toggle
export const SecretField = memo(({ id, label, error, skeleton, ...rest }: SecretFieldProps) => {
  const { t } = useTranslation('admin-mobifull')
  const [revealed, setRevealed] = useState(false)

  if (skeleton) {
    return (
      <div className="form-group">
        <span className="form-label">{label}</span>
        <Skeleton shape="input" />
      </div>
    )
  }
  return (
    <div className="form-group">
      <Label htmlFor={id}>{label}</Label>
      <div className="secret-field">
        <Input
          id={id}
          type={revealed ? 'text' : 'password'}
          error={!!error}
          spellCheck={false}
          {...rest}
        />
        <Button
          variant="secondary"
          className="secret-field__toggle"
          aria-controls={id}
          aria-pressed={revealed}
          onClick={() => setRevealed(r => !r)}>
          {revealed ? t('common.actions.hide') : t('common.actions.show')}
        </Button>
      </div>
      <ErrorMessage message={error} />
    </div>
  )
})

SecretField.displayName = 'SecretField'
